import {
  canPlaceImage,
  isImageInsideObstacle,
  isPositionFree,
} from "../canvasFunction";
import { updateRoofDetails } from "../../../../Features/quantityInfo";
import { panelInformation } from "../../../DataFiles/panelInformation";
import { generationLosses } from "../../Functions/generationCalculate";
import { getPixelsPerMeter } from "./smithStructure";

export const portraitPlacement = ({
  roofInfo,
  structureItem,
  dispatch,
  abstacles,
  gridInfo,
  limitCapacity,
  quantityInfo,
  roofDetail,
}) => {
  const roofPolygons = roofInfo?.value?.polygonCoordinates
    ? roofInfo.value.polygonCoordinates
    : [];
  sessionStorage.setItem("structureItem", JSON.stringify(structureItem));

  let pixelMultiple = getPixelsPerMeter(roofInfo);

  const rowDistance =
    roofDetail.customCapacityType === "Auto"
      ? structureItem.gap * 1000
      : roofDetail.rowDistance;
  const panelInfo = panelInformation.find(
    (item) => item.brand === roofDetail.module
  );
  const panel = panelInfo.panelType.find(
    (item) => item.name === roofDetail.moduleType
  );
  const imgSrc = structureItem.structureImgSrc;
  const imgDimension = {
    height: panel.height * pixelMultiple,
    width: panel.width * pixelMultiple,
    gap: (rowDistance / 1000) * pixelMultiple,
  };

  const newImages = [];
  const walkWayImages = [];
  const polygonCoordinates = roofPolygons[quantityInfo.roofNo].updatedPoints;
  const adjustedPoints = polygonCoordinates.flatMap((point) => [
    point.x,
    point.y,
  ]);
  const minX = Math.min(...adjustedPoints.filter((_, i) => i % 2 === 0));
  const minY = Math.min(...adjustedPoints.filter((_, i) => i % 2 === 1));
  const maxX = Math.max(...adjustedPoints.filter((_, i) => i % 2 === 0));
  const maxY = Math.max(...adjustedPoints.filter((_, i) => i % 2 === 1));
  const unitValue = gridInfo.unit === "m" ? 1 : 0.305;
  const angleDegrees = 0;
  const sideSpace = pixelMultiple * roofDetail.sideSpace * unitValue;
  let x = minX + sideSpace;
  let y = minY;
  let col = 0;
  let row = 0;
  let isFirstRowPlaced = false;
  let patternCol = 0;
  let updateCondition = true;

  while (y <= maxY) {
    while (x <= maxX) {
      if (limitCapacity !== 0 && newImages.length > limitCapacity) {
        updateCondition = false;
      }
      if (
        updateCondition &&
        canPlaceImage(
          x,
          y,
          imgDimension.width,
          imgDimension.height,
          polygonCoordinates,
          angleDegrees
        ) &&
        isPositionFree(
          x,
          y,
          imgDimension.width,
          imgDimension.height,
          newImages
        ) &&
        isImageInsideObstacle(
          x,
          y,
          imgDimension.width,
          imgDimension.height,
          abstacles
        )
      ) {
        col++;
        patternCol++;
        if (col === 1) {
          isFirstRowPlaced = true;

          if (row === 0) {
            row = 1;
            y += sideSpace;
          }
        }
        const imageId =
          Date.now().toString(36) + Math.random().toString(36).substr(2, 5);
        const newImage = {
          id: imageId,
          src: imgSrc,
          x: x,
          y: y,
          width: imgDimension.width,
          height: imgDimension.height,
          type: structureItem.name,
          gap: imgDimension.gap,
          angleDegree: 0,
        };
        newImages.push(newImage);
        if (
          patternCol % roofDetail.blockCol === 0 &&
          roofDetail.walkWayType === "With" &&
          roofDetail.customCapacityType !== "Auto"
        ) {
          let startWalkY = newImages.length > 0 ? newImages[0].y : y;
          let walkWayDimension = pixelMultiple * 1.5 * unitValue;
          let lastY =
            minY +
            pixelMultiple * roofDetail.sideSpace * unitValue +
            walkWayDimension;
          let startX =
            x +
            imgDimension.width +
            pixelMultiple * unitValue * ((roofDetail.walkWay - 1.5) / 2);
          if (lastY < startWalkY) {
            startWalkY = lastY;
          }

          while (startWalkY < y + imgDimension.height) {
            if (
              canPlaceImage(
                startX,
                startWalkY,
                walkWayDimension,
                walkWayDimension,
                polygonCoordinates,
                angleDegrees
              ) &&
              isImageInsideObstacle(
                startX,
                startWalkY,
                walkWayDimension,
                walkWayDimension,
                abstacles
              ) &&
              isPositionFree(
                startX,
                startWalkY,
                walkWayDimension,
                walkWayDimension,
                walkWayImages
              )
            ) {
              const walkWayImage = {
                id: walkWayImages.length,
                src: "./images/structureTransparent/walkWay.webp",
                x: startX,
                y: startWalkY,
                width: walkWayDimension,
                height: walkWayDimension,
              };
              walkWayImages.push(walkWayImage);
              lastY = startWalkY;
              startWalkY += walkWayDimension;
            } else {
              startWalkY++;
            }
          }

          x +=
            imgDimension.width + pixelMultiple * roofDetail.walkWay * unitValue;
        } else {
          x += imgDimension.width;
        }
      } else {
        patternCol++;
        if (
          patternCol % roofDetail.blockCol === 0 &&
          roofDetail.walkWayType === "With" &&
          roofDetail.customCapacityType !== "Auto"
        ) {
          x +=
            imgDimension.width + pixelMultiple * roofDetail.walkWay * unitValue;
        } else {
          x += imgDimension.width;
        }
      }
    }
    col = 0;
    patternCol = 0;
    x = minX + sideSpace;
    if (row === 0 && !isFirstRowPlaced) {
      y += 1;
    } else {
      if (
        row % roofDetail.blockRow === 0 &&
        roofDetail.walkWayType === "With" &&
        roofDetail.customCapacityType !== "Auto"
      ) {
        let walkWayDimension = pixelMultiple * 1.5 * unitValue;
        let startWalkX = x + walkWayDimension;
        let startY =
          y +
          imgDimension.height +
          pixelMultiple * unitValue * ((roofDetail.walkWay - 1.5) / 2);
        while (startWalkX < maxX) {
          if (
            canPlaceImage(
              startWalkX,
              startY,
              walkWayDimension,
              walkWayDimension,
              polygonCoordinates,
              angleDegrees
            ) &&
            isImageInsideObstacle(
              startWalkX,
              startY,
              walkWayDimension,
              walkWayDimension,
              abstacles
            ) &&
            isPositionFree(
              startWalkX,
              startY,
              walkWayDimension,
              walkWayDimension,
              walkWayImages
            )
          ) {
            const walkWayImage = {
              id: walkWayImages.length,
              src: "./images/structureTransparent/walkWayRotate.webp",
              x: startWalkX,
              y: startY,
              width: walkWayDimension,
              height: walkWayDimension,
            };
            walkWayImages.push(walkWayImage);
            startWalkX += walkWayDimension;
          } else {
            startWalkX++;
          }
        }
        y +=
          imgDimension.height + pixelMultiple * roofDetail.walkWay * unitValue;
      } else {
        y += imgDimension.height + imgDimension.gap;
      }
      row++;
    }
  }

  calculatePortraitPlacement({
    newImages,
    walkWayImages,
    structureItem,
    dispatch,
    roofInfo,
    quantityInfo,
    roofDetail,
  });
};

export const calculatePortraitPlacement = ({
  newImages,
  walkWayImages,
  structureItem,
  dispatch,
  quantityInfo,
  roofDetail,
  roofInfo,
}) => {
  const shedDetail = {
    endClamp: 0,
    midClamp: 0,
    rails: 0,
    fullRailLength: 0,
    walkWayLength: 0,
  };
  const lastImage = newImages[newImages.length - 1];
  for (let i = 0; i < newImages.length; i++) {
    const element = newImages[i];
    if (element.id === newImages[0].id) {
      shedDetail.endClamp += 2;
    } else if (newImages[i - 1].y.toFixed(2) !== element.y.toFixed(2)) {
      shedDetail.endClamp += 4;
      if (element.id === lastImage.id) {
        shedDetail.endClamp += 2;
      }
    } else if (
      (element.x - newImages[i - 1].x).toFixed(2) !== element.width.toFixed(2)
    ) {
      shedDetail.endClamp += 4;
    } else if (
      (element.x - newImages[i - 1].x).toFixed(2) === element.width.toFixed(2)
    ) {
      shedDetail.midClamp += 2;
      if (element.id === lastImage.id) {
        shedDetail.endClamp += 2;
      }
    }
  }
  shedDetail.rails = shedDetail.endClamp + shedDetail.midClamp;
  const railLength = Number(
    newImages.length * 2 * structureItem.width * 3.28084 +
      (shedDetail.endClamp * 50) / 304.8
  );
  shedDetail.fullRailLength = Number(
    (railLength + (railLength * 4) / 100).toFixed(1)
  );
  shedDetail.walkWayLength = Number((walkWayImages.length * 1.5).toFixed(2));
  let panelInfo = panelInformation.find(
    (item) => item.brand === roofDetail.module
  );
  let panel = panelInfo.panelType.find(
    (item) => item.name === roofDetail.moduleType
  );

  const totalKilowatt = Number(
    (newImages.length * (panel.pMax / 1000)).toFixed(1)
  );

  if (structureItem.name === "Smith Through Rail P") {
    shedDetail.rails = 0;
  } else {
    shedDetail.fullRailLength = 0;
  }
  const rowDistance =
    roofDetail.customCapacityType === "Auto"
      ? structureItem.gap * 1000
      : roofDetail.rowDistance;
  const azimuth =
    roofDetail.customCapacityType === "Auto" ? 180 : roofDetail.azimuth;

  const myObject = {
    images: newImages,
    structureType: "Single",
    totalKilowatt: totalKilowatt,
    customCapacity: totalKilowatt,
    totalStructure: "--",
    pvModule: newImages.length,
    endClamp: shedDetail.endClamp,
    midClamp: shedDetail.midClamp,
    price: structureItem.price,
    mountingStructure: structureItem.name,
    railLength: shedDetail.fullRailLength,
    walkWayLength: shedDetail.walkWayLength,
    beam: 0,
    polls: 0,
    azimuth: azimuth,
    rowDistance: rowDistance,
    rails: shedDetail.rails,
    multipleStructure: [],
  };
  dispatch(
    updateRoofDetails({
      index: quantityInfo.roofNo,
      fields: myObject,
    })
  );

  const value = { ...roofDetail, ...myObject };
  generationLosses( value, quantityInfo, dispatch);

};
